import React, {Component, Fragment} from 'react';
import _ from 'lodash';
import moment from 'moment';
import momentBusiness from 'moment-business-days';
import { connect } from "react-redux";
import ViewHeader from '../view-header';
import ReactToPrint from "react-to-print";
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import { Link, Redirect } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import ModalComponent from '../../../../components/Modal';
import Notice from "../../../../components/Notification/newNotification";
import ViewForPrinting from '../../../../components/CaseDetails/ViewForPrinting'
import { editCase, getCase, cancelCase, getAvailableUnits } from "./actions";
import { FormText } from 'reactstrap';
import ReactTooltip from "react-tooltip";
import Images from "../../../../components/Images/Images";
import HistoryWrapper from "../../../../components/History/wrapper";
import { addBooking, addPatient, addPickup, getPatient, getCase as getCaseDetails } from "../Home/actions";
import RouteLeavingGuard from "../../../../components/RouteLeavingGuard";
import Spinner from '../../../../components/Spinner';
import { globals } from "../../../../../../common/constants";
import PatientsTable from "../PatientsTable";

// Images
import SubcaseForm from "../../../../components/SubCaseForm";
import { ADD_CASE_SUCCESS_MESSAGE, SCHEDULE_PICKUP_CASE_SUCCESS_MESSAGE } from "../../../../shared/constants";
import {getVacationDaysRequest} from "../../Admin/dashboard/actions";
import {
    getNext8BusinessDays,
    isNonWorkingDay,
    findBusinessDays,
    is8BusinessDayBeforeReturnDate
} from "../../../../helpers";
import { processImageUpdate } from "../../Admin/AdminCaseDetails/helpers";
import {DAYS_UNTIL_READY} from "../../../../components/Home/constants";
import {removeAllImageUploads, startImageUploading} from "../../../../shared/redux/actions";
const IMPLANT_IS_CHECKED = '1'

class CaseDetails extends Component {
    constructor(props) {
        super(props);
        this.bridgesRef = React.createRef();
        this.state = {
            parentBridges: [],
            parentCheckedTeeth:[],
            parentPrevCheckedTeeth: [],
            showImages: false,
            fromCase: false,
            approvable: false,
            tableOption: {
                noDataText: 'No case is available yet.',
                hideSizePerPage: true,
                sizePerPage: 10,
                onRowClick: (row) => this.linkToCase(row),
                page: 1
            },
            selectRowProp: {
                mode: 'radio',
                className: 'selectedItemInTable',
                hideSelectColumn: true,
                clickToSelect: true
            },
            implantsPartObject: {
                1: { name: 'Impression coping ', number: 0 },
                2: { name: 'Impression screw ', number: 0 },
                3: { name: 'Lab analog ', number: 0 },
                4: { name: 'Prosthetic screw ', number: 0 },
                5: { name: 'Abutment/Ti', number: 0 },
                6: { name: 'Other ', number: 0 }
            },
            enclosedBoxObject: {
                1: { name: 'Impression/master model' },
                2: { name: 'Antagonist model/impression' },
                3: { name: 'Bite' },
                4: { name: 'Pre-op/temp model/impression' },
                5: {name:  'Optical scan'},
                6: { name: 'Implant parts' },
                7: { name: 'Other ' }
            },
            after24Hour: false,
            showEditModal: false,
            modalBody: '',
            modalHeader: 'Request Change',
            printingBlockShow: false,
            availableUnits: 0,
            redirect: false,
            validationBooking: {
                patientId: false,
                implantParts: false,
                sendingDate: false,
                numberOfUnits: false,
                type: false,
                implant: false,
                enclosedBox: false,
                returnDate: false
            },
            currentNumberOfUnits: 0,
            prevStatus: '',
            patient: {
                bookingId: 0,
                status: '',
                dateOfSubmission: '',
                sendingDate: '',
                dateOfReturn: '',
                patientId: '',
                numberOfUnits: '',
                type: '',
                notes: '',
                color: '',
                signature: '',
                license: '',
                implant: '',
                implantType: '',
                implantSize: '',
                admin_case_notes:'',
                enclosedBox: [],
                implantParts: {},
                images: [],
                isArchived: false,
                is_received: false,
                bridges:[],
            },
            bridgesStructure: {
                top: {
                    left: {
                        '_13': {index: 5, number: 13}, '_14': {index: 4, number: 14}, '_15': {index: 3, number: 15}, '_16': {index: 2, number: 16}, '_17': {index: 1, number: 17}, '_18': {index: 0, number: 18},
                    },
                    center: {
                        '_12': {index: 6, number: 12}, '_11': {index: 7, number: 11}, '_21': {index: 8, number: 21}, '_22': {index: 9, number: 22},
                    },
                    right: {
                        '_23': {index: 10, number: 23}, '_24': {index: 11, number: 24}, '_25': {index: 12, number: 25}, '_26': {index: 13, number: 26}, '_27': {index: 14, number: 27}, '_28': {index: 15, number: 28},
                    },
                },
                bottom: {
                    left: {
                        '_48': {index: 0, number: 48}, '_47': {index: 1, number: 47}, '_46': {index: 2, number: 46}, '_45': {index: 3, number: 45}, '_44': {index: 4, number: 44}, '_43': {index: 5, number: 43},
                    },
                    center: {
                        '_42': {index: 6, number: 42}, '_41': {index: 7, number: 41}, '_31': {index: 8, number: 31}, '_32': {index: 9, number: 32},
                    },
                    right: {
                        '_38': {index: 15, number: 38}, '_37': {index: 14, number: 37}, '_36': {index: 13, number: 36}, '_35': {index: 12, number: 35}, '_34': {index: 11, number: 34}, '_33': {index: 10, number: 33},
                    },
                }
            },
            checkedTeeth:[],
            prevCheckedTeeth: [],
            eightBusinessDaysFromCurrentDate: getNext8BusinessDays(),
            businessDaysBeforeReturnDate: [],
            bridges:[],
            caseId: this.props.match.params.caseId,
            hasErrorImages: false,
            isOpenSubcaseForm: false,
            printModal: false,
            isOpenPickupModal: false,
            buttonDisabled: true,
            isCasesTableOpen: false,
            isCancelCaseModalOpened: false,
            isDirty: false
        };
        this.handleDateChange = this.handleDateChange.bind(this);
        this.getPatientNameById = this.getPatientNameById.bind(this);
        this.toggleSubcaseFormModal = this.toggleSubcaseFormModal.bind(this);
        this.linkToCasePage = this.linkToCasePage.bind(this);
        this.cancelEdits = this.cancelEdits.bind(this);

    }

    togglePrintModal = () => {
        let isOpenPickupModal = false;
        if (this.state.printModal) {
            isOpenPickupModal = true;
        }
        this.setState(prevState => ({
            printModal: !prevState.printModal,
            isOpenPickupModal,
            isOpenSubcaseForm: false,
        }));
    };

    componentDidMount() {
        document.title = "Case " + this.state.caseId;
        this.props.getVacationDays();
        const locationState = this.props.history.location.state;
        this.props.getCase(this.state.caseId);
        this.props.getPatient({});
        if (this.table && locationState && locationState.pageNumber) {
            this.setState(prevState => ({
                option: {
                    ...prevState.option,
                    page: locationState.pageNumber,
                }
            }))
        }
        if (this.props.location.state && this.props.location.state.showImages) {
            this.setState({
                showImages: true
            })
        }
    }

    componentDidUpdate(prevProps) {
        const {caseId: paramCaseId} = this.props.match.params;
        const {locationToRedirect} = this.state;
        if (this.state.caseId !== paramCaseId) {
            this.props.getCase(paramCaseId);
            document.title = "Case " + paramCaseId;
            this.setState({
                caseId: paramCaseId,
            });
        }

        if(this.props.caseIsDeleted){
            Notice.addNotification('Case deleted successfully.','success')
        }

        if (prevProps.caseDetails.success === null && locationToRedirect && this.props.caseDetails.success) {
            this.props.history.push(locationToRedirect);
        }
        if (prevProps.caseDetails.success === null && this.props.caseDetails.success) {
            this.setState({
                approvable: false
            })
        }

        if(prevProps.vacationDays !== this.props.vacationDays){
            if (this.props.vacationDays.length) {
                this.setState({
                    eightBusinessDaysFromCurrentDate: getNext8BusinessDays(this.props.vacationDays),
                })

            }
        }

        const isAvailableUnitsFetched = prevProps.caseDetails.isFetching && !this.props.caseDetails.isFetching;
        const isReturnDateChanged = this.props.caseDetails.caseList.caseDetails && this.props.caseDetails.dateOfReturn !== this.props.caseDetails.caseList.caseDetails.date_of_return;
         if (isAvailableUnitsFetched && isReturnDateChanged) {
             this.setState({
                 approvable: this.checkIsNeedToAdminRequest(),
             });
         }

    }

    handleDateChange(date) {
        if (date) {
            this.setState({
                patient: {
                    ...this.state.patient,
                    dateOfReturn: moment(date).format('YYYY-MM-DD'),
                },
                buttonDisabled: false,
                isDirty: true,
            }, prevState => {
                this.props.getAvailableUnits({
                    date: moment(date).format('YYYY-MM-DD'),
                    caseId: prevState && prevState.patient.bookingId
                });
            });
        }
        else {
            this.setState(prevState => ({
                patient: {
                    ...prevState.patient,
                    dateOfReturn: date
                },
                buttonDisabled: false
            }))
        }
    }

    linkToCase(row) {
        // this.props.getCase(row.id);
        document.title = "Case " + row.id;
        // this.setState({ caseId: row.id });
        const pageNumber = this.table.getPageByRowKey(row.id);
        const locationState = this.props.location.state;
        this.props.history.push({
            pathname: '/case-details/' + row.id,
            state: {
                page: locationState ? locationState.page : this.props.location.pathname,
                pageName: locationState ? locationState.pageName : 'Cases',
                pageNumber
            }
        });
    }

    handleClose(modalState) {
        const { locationToRedirect } = this.state;
        this.setState({
            showEditModal: false
        }, () => {
            if (modalState === 'close') {
                this.props.history.push(locationToRedirect)
            }
        });
    }

    idFormatter(cell) {
        return "Case " + cell;
    }

    get patientCases() {
        return this.props.caseDetails.caseList.cases
    }

    get caseDetails() {
        return this.props.caseDetails.caseList.caseDetails
    }

    get patientList() {
        return this.props.caseDetails.caseList.patientList || []
    }

    handleChangePatient(selectedOption) {
        this.setState(prevState => ({
            patient: {
                ...prevState.patient,
                ...prevState.select,

                patientId: selectedOption ? selectedOption.value : '',
            },
            buttonDisabled: false,
            isDirty: true,
        }));
    }

    handleChangeSendingDate(sendingDate) {
        this.setState(prevState => ({
            patient: {
                ...prevState.patient,
                sendingDate: sendingDate ? moment(sendingDate).format('YYYY-MM-DD') : sendingDate,
            },
            buttonDisabled: false,
            isDirty: true
        }));
    }

    handleChange(key, value, find = null, isDirty = true) {
        switch (key) {
            case 'enclosedBox': {
                const enclosedBox = this.state.patient[key];
                const find = enclosedBox.find(item => item === value);
                const filteredData = (find > 0) ? enclosedBox.filter(e => e !== value) : [...this.state.patient[key], value];
                this.setState({
                    patient: { ...this.state.patient, [key]: filteredData, },
                    buttonDisabled: false,
                    isDirty: true,
                })
                break;
            }
            case 'implantParts': {
                let updateData, implantParts = this.state.patient[key];
                let buttonDisabled = false;
                if (implantParts[value] !== undefined && !find) {
                    delete implantParts[value]
                    updateData = implantParts;
                } else {
                    updateData = { ...this.state.patient[key], [(find) ? find : value]: (find) ? value : 0 }
                }
                if (_.isEqual(updateData, this.props.caseDetails.caseList.implantParts)) {
                    buttonDisabled = true;
                }
                this.setState({
                    patient: { ...this.state.patient, [key]: updateData, },
                    buttonDisabled,
                    isDirty: true,
                })
                break;
            }
            case 'image': {
                const images = this.state.patient.images;
                if (value.hasError) {
                    this.setState({ hasErrorImages: true });
                } else {
                    this.setState({
                        patient: { ...this.state.patient, images: [...images, ...value.currentImage] },
                        hasErrorImages: false,
                        buttonDisabled: false,
                        isDirty,
                    })
                }
                break;
            }
            case 'notes': {
                this.setState({
                    patient: {
                        ...this.state.patient, [key]: value
                    },
                    buttonDisabled: false,
                    isDirty: true,
                });
                break;
            }
            case 'admin_case_notes': {
                this.setState({
                    patient: {
                        ...this.state.patient, [key]: value
                    },
                    buttonDisabled: false,
                    isDirty: true,
                });
                break;
            }
            case 'signature': {
                this.setState({
                    patient: {
                        ...this.state.patient, [key]: value
                    },
                    buttonDisabled: false,
                    isDirty: true,
                });
                break;
            }
            case 'numberOfUnits': {
                this.setState({
                    patient: {
                        ...this.state.patient, [key]: value,
                    },
                    buttonDisabled: false,
                    isDirty: true,
                    approvable: this.checkIsNeedToAdminRequest(value)
                });
                break;
            }
            case 'type': {
                this.setState({
                    approvable: this.checkIsNeedToAdminRequest(this.state.patient.numberOfUnits, value),
                    patient: {
                        ...this.state.patient,
                        [key]: value,
                    },
                    buttonDisabled: false,
                    isDirty: true,
                })
                break;
            }
            default:
                this.setState({
                    patient: {
                        ...this.state.patient, [key]: value
                    },
                    buttonDisabled: false,
                    isDirty: true,
                })
        }
    }

    checkIsNeedToAdminRequest(changedNumberOfUnits = this.state.patient.numberOfUnits, changedType = this.state.patient.type) {
        let unitsCount = this.state.availableUnits.misc;
        if (changedType === 'zirconia' || changedType === 'ceramic') {
            unitsCount = this.state.availableUnits.zirconia;
        }
        const isReturnDateNotChanged = !this.props.caseDetails.dateOfReturn || this.props.caseDetails.dateOfReturn === this.props.caseDetails.caseList.caseDetails.date_of_return;
        if (isReturnDateNotChanged) {
            unitsCount += this.props.caseDetails.caseList.caseDetails.number_of_units;
        }
        const isPendingCase = this.state.patient.status === globals.PATIENT.STATUS.PENDING;
        return changedNumberOfUnits > unitsCount && !isPendingCase;
    }

    handleSaveBooking(event, pathname) {
        const bookingInfo = this.state.patient;
        const patientId = (bookingInfo.patientId <= 0);
        const numberOfUnits = (bookingInfo.numberOfUnits <= 0);
        const type = (!(bookingInfo.type === 'prototype' || bookingInfo.type === 'zirconia' || bookingInfo.type === 'ceramic' || bookingInfo.type === 'temp' || bookingInfo.type === 'other'));
        const implant = (!(bookingInfo.implant === '1' || bookingInfo.implant === '0'));
        const sendingDate = (!bookingInfo.sendingDate);
        const returnDate = (!bookingInfo.dateOfReturn);
        const enclosedBox = !bookingInfo.enclosedBox.length;
        const isCaseOnHold = bookingInfo.status === globals.PATIENT.STATUS.ON_HOLD;
        const isCasePending = bookingInfo.status === globals.PATIENT.STATUS.PENDING;
        const implantPartValues = Object.values(bookingInfo.implantParts);
        const implantParts = implantPartValues.length > 0 && !implantPartValues.every(Boolean);
        if (patientId || numberOfUnits || type || implant || sendingDate || enclosedBox || returnDate || implantParts) {
            this.setState({
                validationBooking: {
                    patientId: patientId,
                    sendingDate: sendingDate,
                    implantParts,
                    numberOfUnits: numberOfUnits,
                    type: type,
                    implant: implant,
                    enclosedBox: enclosedBox,
                    returnDate: returnDate
                }
            });
        } else {
            event.preventDefault();
            const unitType = this.state.patient.type === 'zirconia' ? this.state.availableUnits.zirconia : this.state.availableUnits.misc;
            const unitsCount = this.state.patient.numberOfUnits > unitType + this.props.caseDetails.caseList.caseDetails.number_of_units ;
            if ((bookingInfo.dateOfReturn !== moment(this.props.caseDetails.caseList.caseDetails.date_of_return).format('YYYY-MM-DD')) &&
                (moment(bookingInfo.dateOfReturn).day() === 0 || moment(bookingInfo.dateOfReturn).day() === 6)) {
                Notice.addNotification('Weekends are not available for booking.', 'error');
            } else if ((bookingInfo.sendingDate !== moment(this.props.caseDetails.caseList.caseDetails.sending_date).format('YYYY-MM-DD')) && moment(bookingInfo.dateOfSubmission) > moment(bookingInfo.sendingDate)) {
                Notice.addNotification('Sending Date should not be early than Submission Date.', 'error');
            } else if (((bookingInfo.sendingDate !== moment(this.props.caseDetails.caseList.caseDetails.sending_date).format('YYYY-MM-DD')) || bookingInfo.dateOfReturn !== moment(this.props.caseDetails.caseList.caseDetails.date_of_return).format('YYYY-MM-DD')) && moment(bookingInfo.sendingDate).add(10, 'day') > moment(bookingInfo.dateOfReturn)) {
                Notice.addNotification('Sending Date should be at least 10 days early than ' + moment(bookingInfo.dateOfReturn).format('DD/MM/YYYY'), 'error');
            } else if (unitsCount && !isCaseOnHold && !isCasePending) {
                if (this.state.showEditModal === true) {
                    this.setState({
                        patient: {
                            ...this.state.patient,
                        }
                    }, async () => await this.editCaseRequest());
                }
                else {
                    this.setState({
                        locationToRedirect: pathname,
                        showEditModal: true,
                        modalHeader: "Request Change",
                        modalBody: "The number of inserted units exceeds the number of available units. The case will be pending confirmation from the lab, are you sure you want to submit changes?",
                        isDirty: false,
                    });
                }
            }
            else {
                if (this.state.showEditModal === true) {

                    this.setState({
                        patient: {
                            ...this.state.patient,
                        }
                    }, async () => await this.editCaseRequest());
                } else {
                    const currentType = this.state.patient.type === 'zirconia' ? 'zirconia' : 'misc';
                    const initialType = this.props.caseDetails.caseList.caseDetails.type === 'zirconia' ? 'zirconia' : 'misc';
                    let unitsCount;
                    const unitType = currentType === 'zirconia' ? this.state.availableUnits.zirconia : this.state.availableUnits.misc;
                    if(currentType === initialType) {
                        unitsCount = this.state.patient.numberOfUnits > unitType + this.props.caseDetails.caseList.caseDetails.number_of_units;
                    } else {
                        unitsCount = this.state.patient.numberOfUnits > unitType;
                    }
                    if (!isCaseOnHold && this.state.approvable && (!_.isEqual(this.state.patient.sendingDate, this.props.caseDetails.caseList.caseDetails.sending_date) ||
                        !_.isEqual(this.state.patient.dateOfReturn, this.props.caseDetails.caseList.caseDetails.date_of_return) ||
                        unitsCount)
                    ) {
                        this.setState({
                            locationToRedirect: pathname,
                            showEditModal: true,
                            modalHeader: "Request Change",
                            isDirty: false,
                            modalBody: "Changes will be pending confirmation from the lab admin",
                            patient: {
                                ...this.state.patient,
                                status: 'pending'
                            }
                        });
                    } else {
                        this.setState({
                            patient: {
                                ...this.state.patient,
                            },
                            isDirty: false,
                            locationToRedirect: pathname
                        }, async () => {
                            await this.editCaseRequest()
                        });
                    }
                }
            }
        }
    }

    async editCaseRequest() {
        await processImageUpdate(this.state, this.bridgesRef.current);
        this.props.editCase({...this.state.patient, images: this.state.patient.images.map(({filename}) => ({filename}))});
        this.setState({ showEditModal: false });
    }

    getPatientNameById(patientId) {
        const patient = this.patientList.find(item => {
            return item.id === patientId;
        });
        return patient;
    }

    cancelBooking() {
        this.setState({
            isDirty: false,
        }, () => this.props.cancelCase(this.state.caseId));

    }

    makeBridge = (from,to) => {
        this.setState({isDirty:true,buttonDisabled:false})
        const bridges = this.state.patient.bridges;
        const checkedTeeth = this.state.checkedTeeth;
        if(from === to) {
            if(bridges.length){
                if(checkedTeeth.includes(from) && checkedTeeth.includes(to)){
                    const filteredBridge = bridges.filter((bridge)=> {
                        return bridge.from !== from
                    })
                    const filteredTeeth = checkedTeeth.filter((teeth)=>{
                        return teeth !== from;
                    })
                    this.setState({
                        checkedTeeth:filteredTeeth,
                        patient:{...this.state.patient,bridges:filteredBridge}
                    })
                } else {
                    bridges.push({from:from, to:to})
                    checkedTeeth.push(from);
                    this.setState({
                        checkedTeeth:checkedTeeth,
                        patient:{...this.state.patient,bridges:bridges}
                    })
                }
            }else {
                checkedTeeth.push(to);
                bridges.push({from:from,to:to})
                this.setState({
                    checkedTeeth:checkedTeeth,
                    patient:{...this.state.patient,bridges:bridges}
                })
            }

        } else {
            if(checkedTeeth.includes(from) && checkedTeeth.includes(to) && from !== 11 && from !== 41){
                let isBridged = false;
                const filteredBridges = bridges.filter(bridge => {
                    if (bridge.from === from && bridge.to === to) {
                        isBridged = true;
                        return false;
                    }
                    return bridge.from !== from && bridge.to !== to;
                })
                if(isBridged){
                    const filteredTeeth = checkedTeeth.filter((teeth)=>{
                        return teeth !== from && teeth !== to;
                    })
                    this.setState({
                        checkedTeeth:filteredTeeth,
                        patient:{
                            ...this.state.patient,
                            bridges: filteredBridges
                        }
                    })
                } else {
                    bridges.push({from:from,to:to});
                    this.setState({
                        patient:{...this.state.patient,bridges:bridges}
                    })
                }
            } else {
                if(from === 11){
                    let isBridged = false;
                    if(checkedTeeth.includes(from) && checkedTeeth.includes(21)){
                        const filteredBridges = bridges.filter(bridge => {
                            if (bridge.from === from && bridge.to === 21) {
                                isBridged = true;
                                return false;
                            }
                            return bridge.from !== from && bridge.to !== 21;
                        })
                        if(isBridged){
                            const filteredTeeth = checkedTeeth.filter((teeth)=>{
                                return teeth !== from && teeth !== 21;
                            })
                            this.setState({
                                checkedTeeth:filteredTeeth,
                                patient:{
                                    ...this.state.patient,
                                    bridges: filteredBridges
                                }
                            })
                        } else {
                            bridges.push({from:from, to:21});
                            checkedTeeth.push(from,21);
                            this.setState({
                                checkedTeeth:checkedTeeth,
                                patient:{...this.state.patient,bridges:bridges}
                            })
                        }
                    }else {
                        bridges.push({from:from, to:21});
                        checkedTeeth.push(from,21);
                        this.setState({
                            checkedTeeth:checkedTeeth,
                            patient:{...this.state.patient,bridges:bridges}
                        })
                    }
                } else if(from === 41){
                    let isBridged = false;
                    if(checkedTeeth.includes(from) && checkedTeeth.includes(31)){
                        const filteredBridges = bridges.filter(bridge => {
                            if (bridge.from === from && bridge.to === 31) {
                                isBridged = true;
                                return false;
                            }
                            return bridge.from !== from && bridge.to !== 31;
                        })
                        if(isBridged){
                            const filteredTeeth = checkedTeeth.filter((teeth)=>{
                                return teeth !== from && teeth !== 31;
                            })
                            this.setState({
                                checkedTeeth:filteredTeeth,
                                patient:{
                                    ...this.state.patient,
                                    bridges: filteredBridges
                                }
                            })
                        } else {
                            bridges.push({from:from, to:31});
                            checkedTeeth.push(from,31);
                            this.setState({
                                checkedTeeth:checkedTeeth,
                                patient:{...this.state.patient,bridges:bridges}
                            })
                        }
                    }else {
                        bridges.push({from:from, to:31});
                        checkedTeeth.push(from,31);
                        this.setState({
                            checkedTeeth:checkedTeeth,
                            patient:{...this.state.patient,bridges:bridges}
                        })
                    }

                } else {
                    bridges.push({from: from, to: to});
                    checkedTeeth.push(from, to);
                    this.setState({
                        checkedTeeth: checkedTeeth,
                        patient: {...this.state.patient, bridges: bridges}
                    })
                }
            }
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        const caseDetails = nextProps.caseDetails.caseList.caseDetails;
        if (caseDetails && !_.isEqual(this.state, nextState)) {
            const details = {
                bookingId: caseDetails.id,
                sendingDate: moment(caseDetails.sending_date).format('YYYY-MM-DD'),
                status: caseDetails.status,
                dateOfSubmission: caseDetails.date_of_submission,
                dateOfReturn: moment(caseDetails.date_of_return).format('YYYY-MM-DD'),
                patientId: caseDetails.patient.id,
                numberOfUnits: caseDetails.number_of_units.toString(),
                type: caseDetails.type,
                notes: caseDetails.notes,
                color: caseDetails.color,
                signature: caseDetails.signature,
                license: caseDetails.license,
                implant: caseDetails.implant.toString(),
                implantType: caseDetails.implant_type,
                implantSize: caseDetails.implant_size,
                enclosedBox: this.props.caseDetails.caseList.enclosedBox,
                implantParts: this.props.caseDetails.caseList.implantParts,
                images: this.props.caseDetails.caseList.images,
                bridges: this.props.caseDetails.bridges,
                prevBridges: this.props.caseDetails.bridges,
            };
            if (_.isEqual(details, nextState.patient)) {
                this.setState({ buttonDisabled: true });
            }
        }
        return true
    }

    componentWillUnmount() {
        this.props.removeAllUploads();
    }

    componentWillReceiveProps(nextProps) {
        const locationState = this.props.location.state;
        if (nextProps.caseDetails.cancelCase &&  !this.props.caseDetails.cancelCase) {
            if(locationState) {

                this.props.history.push({
                    pathname: locationState ? locationState.page : locationState.page,
                    state: {
                        defaultDate: locationState.previous ? locationState.previous.defaultDate : new Date(this.state.patient.dateOfReturn),
                        filterData: locationState.previous ? locationState.previous.filterData : locationState.filterData,
                        pageNumber: locationState.previous ? locationState.previous.filterData : locationState.pageNumber
                    }
                });
            } else {
                this.setState({ redirect: true })
            }
        } else if (nextProps.caseDetails.caseFaller && !this.props.caseDetails.caseFaller) {
            Notice.addNotification('Case is not found.', 'error');
            this.setState({ redirect: true })
        }
        if (nextProps.caseDetails.loading === false && !nextProps.caseDetails.caseFaller) {
            if (nextProps.caseDetails.edited && !this.props.caseDetails.edited) {
                if (nextProps.caseDetails.caseList.caseDetails.sending_date != this.props.caseDetails.caseList.caseDetails.sending_date ||
                    nextProps.caseDetails.caseList.caseDetails.date_of_return != this.props.caseDetails.caseList.caseDetails.date_of_return ||
                    this.state.patient.numberOfUnits > this.state.availableUnits + this.props.caseDetails.caseList.caseDetails.number_of_units
                ) {
                    this.props.startImageUploading({ caseId: this.state.caseId, isAdmin: false });
                    Notice.addNotification('Case is successfully updated.', 'success')
                } else {
                    this.props.startImageUploading({ caseId: this.state.caseId, isAdmin: false });
                    Notice.addNotification('Your changes have been saved', 'success')
                }
                this.setState({
                    buttonDisabled: true,
                    validationBooking: {
                        patientId: false,
                        sendingDate: false,
                        implantParts: false,
                        numberOfUnits: false,
                        type: false,
                        implant: false,
                        enclosedBox: false,
                        returnDate: false
                    }
                });
            } else if (nextProps.caseDetails.editFailer && !this.props.caseDetails.editFailer) {
                Notice.addNotification('Something went wrong.', 'error');
            }
            const { caseDetails } = nextProps.caseDetails.caseList;
            if(nextProps.caseDetails.availableUnits) {
                this.setState({
                    availableUnits: nextProps.caseDetails.availableUnits
                });
            }

            if (caseDetails !== undefined && nextProps.caseDetails.getCasesSuccess && !this.props.caseDetails.getCasesSuccess) {
                const dateOfSubmission = moment(caseDetails.date_of_submission);
                const dateNow = moment();
                const diff = dateNow.diff(dateOfSubmission, 'hours');
                var after24Hour = (diff > 24) ? true : false;
                this.setState({
                    after24Hour: after24Hour,
                    availableUnits: (nextProps.caseDetails.availableUnits !== undefined)
                        ?
                        nextProps.caseDetails.availableUnits
                        :
                        nextProps.caseDetails.caseList.avaliableUnits,
                    currentNumberOfUnits: (nextProps.caseDetails.myUnits !== undefined) ? nextProps.caseDetails.myUnits : caseDetails.number_of_units,
                    prevStatus: nextProps.caseDetails.caseList.caseDetails.prevStatus,
                    businessDaysBeforeReturnDate: findBusinessDays(this.props.vacationDays,moment((nextProps.caseDetails.dateOfReturn !== undefined) ? nextProps.caseDetails.dateOfReturn : caseDetails.date_of_return).format('YYYY-MM-DD'),8),
                    patient: {
                        bookingId: caseDetails.id,
                        status: caseDetails.status,
                        dateOfSubmission: caseDetails.date_of_submission,
                        sendingDate: moment(caseDetails.sending_date).format('YYYY-MM-DD'),
                        dateOfReturn: moment((nextProps.caseDetails.dateOfReturn !== undefined) ? nextProps.caseDetails.dateOfReturn : caseDetails.date_of_return).format('YYYY-MM-DD'),
                        patientId: caseDetails.patient.id,
                        numberOfUnits: caseDetails.number_of_units.toString(),
                        type: caseDetails.type,
                        notes: caseDetails.notes,
                        color: caseDetails.color,
                        signature: caseDetails.signature,
                        license: caseDetails.license,
                        implant: caseDetails.implant.toString(),
                        implantType: caseDetails.implant_type,
                        implantSize: caseDetails.implant_size,
                        enclosedBox: nextProps.caseDetails.caseList.enclosedBox,
                        implantParts: nextProps.caseDetails.caseList.implantParts,
                        images: nextProps.caseDetails.caseList.images,
                        isArchived: caseDetails.isArchived,
                        is_received: caseDetails.is_received,
                        bridges: nextProps.bridges
                    },
                    validationBooking: {
                        patientId: false,
                        sendingDate: false,
                        implantParts: false,
                        numberOfUnits: false,
                        type: false,
                        implant: false,
                        enclosedBox: false,
                        returnDate: false
                    }
                })
            }
            const checkTeeths = [];
            nextProps.bridges && nextProps.bridges.forEach((item)=>{
                if(item.from !== item.to){
                    if(!this.state.checkedTeeth.includes(item.from)){
                        checkTeeths.push(item.from);
                    }
                    if(!this.state.checkedTeeth.includes(item.to)){
                        checkTeeths.push(item.to);
                    }
                }else{
                    checkTeeths.push(item.to);
                }
            })
            this.setState({
                checkedTeeth:checkTeeths,
                prevCheckedTeeth: [...checkTeeths]
            })

            const { dateOfReturn, availableUnits } = nextProps.caseDetails;
            if (this.props.caseDetails.dateOfReturn !== dateOfReturn ) {
                if (availableUnits && availableUnits.zirconia === 0) {
                    this.setState({
                        patient: {
                            ...this.state.patient,
                            type: '',
                        }
                    })
                }
            }
        }

        if (this.props.imageUpload.uploadingComplete && !this.props.imageUpload.uploadingImages && !this.props.imageUpload.hasErrors && this.state.isOpenSubcaseForm) {
            this.togglePrintModal();
        }

        if (nextProps.home.addBookingRequest && !this.props.home.addBookingRequest) {
            Notice.addNotification(ADD_CASE_SUCCESS_MESSAGE, 'success');
            this.props.startImageUploading({caseId: nextProps.home.addedData,isAdmin: false});
        } else if (nextProps.home.addBookingRequest === false && this.props.home.addBookingRequest) {
            Notice.addNotification('Your session is expired.', 'error');
            this.setState({ moreThenAvailableUnitsModal: false, deletePatientModal: false, validationBooking: { patient_id: false, number_of_units: false, type: false,implantParts: false, sending_date: false, enclosedBox: false }, addNewPatient: false, addBookingShow: this.state.openBookingFormAfterAddNewPatient, openBookingFormAfterAddNewPatient: false });
        } else if (nextProps.home.added && !this.props.home.added) {
            Notice.addNotification('Patient is successfully added.', 'success');
            this.setState({ addNewPatient: false, addBookingShow: this.state.openBookingFormAfterAddNewPatient, newPatient: { first_name: '', last_name: '', notes: '' }, validateNewPatient: { first_name: true, last_name: true }, addingBookingInfo: { ...this.state.addingBookingInfo, patient_id: nextProps.home.patientList.newPatient.id } })
        } else if (nextProps.home.pickupScheduled && !this.props.home.pickupScheduled) {
            Notice.addNotification(SCHEDULE_PICKUP_CASE_SUCCESS_MESSAGE, 'success');
            this.setState({ isOpenPickupModal: false });
            this.props.getCase(this.state.caseId);
            this.props.getPatient({});
        }
    }

    cancelEdits() {
        this.setState({
            isDirty: false
        }, this.handleGoBack)
    }

    handleSeeMore() {
        this.setState({ showImages: true, fromCase: true });
    }

    handleGoBack() {
        const locationState = this.props.location.state;
        if (this.state.fromCase) {
            this.setState({ fromCase: false, showImages: false });
        } else {
            if (locationState) {
                this.props.history.push({
                    pathname: locationState.page,
                    state: {
                        defaultDate: locationState.previous ? locationState.previous.defaultDate : new Date(this.state.patient.dateOfReturn),
                        filterData: locationState.previous ? locationState.previous.filterData : locationState.filterData,
                        pageNumber: locationState.previous ? locationState.previous.pageNumber : locationState.pageNumber,
                        page: locationState.previous ? locationState.previous.page : locationState.page,
                        patientId: locationState.previous ? locationState.previous.patientId : locationState.patientId,
                        tabName: locationState.previous ? locationState.previous.tabName : locationState.tabName
                    }
                });
            } else {
                this.props.history.push('/account');
            }
        }
    }

    removeImage(name) {
        this.setState(prevState => ({
            patient: {
                ...prevState.patient,
                images: prevState.patient.images.filter(image => image.filename !== name),
            },
        }));
        if (!_.isEqual(this.state.patient.images.filter(image => image.filename !== name), this.props.caseDetails.caseList.images)) {
            this.setState({
                buttonDisabled: false,
                isDirty: true
            });
        }
    }

    filterOptions(options, filter, currentValues) {
        if (filter) {
            return options.filter(option => {
                const regex = new RegExp("^" + filter.toLowerCase());
                const names = option.label.match(/\S+/g);
                const filtered = names.filter(name => {
                    return name.toLowerCase().match(regex);
                }).length !== 0;
                return filtered ? filtered : option.label.toLowerCase().match(regex);
            });
        }
        return options;

    }

    toggleSubcaseFormModal() {
        const isSubCaseOpened = this.state.isOpenSubcaseForm;
        this.setState((prevState) => ({
                isOpenSubcaseForm: !isSubCaseOpened,
                ...(isSubCaseOpened
                        ? {
                            bridges: prevState.parentBridges,
                            checkedTeeth: prevState.parentCheckedTeeth,
                            prevCheckedTeeth: prevState.parentPrevCheckedTeeth,
                        }
                        :
                        {
                            parentBridges: prevState.patient.bridges,
                            patient: {...prevState.patient, bridges: []},
                            checkedTeeth: [],
                            prevCheckedTeeth: [],
                            parentCheckedTeeth: prevState.checkedTeeth,
                            parentPrevCheckedTeeth: prevState.parentPrevCheckedTeeth
                        }
                ),
            })
        );
    }

    handleClosePickupModal() {
        this.setState({isOpenPickupModal: false});
        Notice.addNotification('You can schedule a pickup from Cases menu when the case is ready', 'success');
        this.props.getCase(this.state.caseId);
        this.props.getPatient({});
    }

    schedulePickup() {
        this.props.addPickup(this.props.home.patientList.caseDetails.id, true)
    }

    toggleSubcasesTable() {
        this.setState(prevState => ({
            isCasesTableOpen: !prevState.isCasesTableOpen
        }));
    };

    linkToCasePage(row) {
        this.props.history.push({
            pathname: '/case-details/' + row.id,
            state: {
                page: '/case-details/' + row.parent_id,
                pageName: 'Case Details',
                previous: {
                    ...this.props.location.state,
                    page: this.props.location.state.page,
                    defaultDate: new Date(this.state.patient.dateOfReturn)
                }
            }
        });
    }

    toggleCancelModal = () => {
        this.setState((prevState => ({ isCancelCaseModalOpened: !prevState.isCancelCaseModalOpened })));
    }

    getMinSubmissionDate() {
        let countDays = 0;
        let subtractDays = DAYS_UNTIL_READY + 4;
        if(moment(this.state.patient.dateOfReturn).day() === 4 || moment(this.state.patient.dateOfReturn).day() === 5){
            subtractDays = DAYS_UNTIL_READY + 2;
        }
        this.props.vacationDays && this.props.vacationDays.forEach((vacationDaysItem)=>{
            const returnDate = moment(this.state.patient.dateOfReturn);
            const subtractedReturnDate = moment(this.state.patient.dateOfReturn).subtract(subtractDays,'days');

            const vacationStart = moment(vacationDaysItem.start);
            const vacationEnd = moment(vacationDaysItem.end);

            if(
                vacationEnd.isBetween(subtractedReturnDate, returnDate, 'days', '[]') &&
                !vacationStart.isBetween(subtractedReturnDate, returnDate, 'days', '[]')
            ){
                countDays+=(vacationEnd.diff(vacationStart,'days') + 1);
            }
            if(
                vacationStart.isBetween(subtractedReturnDate, returnDate, 'days', '[]')
            ) {
                if (vacationEnd.isBetween(subtractedReturnDate, returnDate, 'days', '[]')) {
                    countDays+=(vacationEnd.diff(vacationStart,'days') + 1);
                    return
                }
                countDays+=(returnDate.diff(vacationStart,'days') + 1)
            }
        })
        let minDate = null;
        if(this.props.isSubcase){
            minDate = moment(this.props.minDateForSubcase).subtract(12, 'days');
            return minDate;
        } else {
            minDate = moment(this.state.patient.dateOfReturn).subtract(
                // +countDays for vacation days, +2 days for the weekdays
                countDays ? subtractDays + countDays : subtractDays, 'days'
            )
            const minDateWeekday = minDate.day();

            // If it's sunday
            if (minDateWeekday === 0) {
                return minDate.subtract(2, 'days');
            }

            // If it's saturday
            if (minDateWeekday === 6) {
                return minDate.subtract(1, 'days');
            }

            return moment(minDate,"DD/MM/YYYY");
        }
    }

    formatDate = (date) => moment(date).format("YYYY-MM-DD")

    isDateDisabled = (date) => {
        const formattedDate = this.formatDate(date);
        return isNonWorkingDay(date, this.props.vacationDays) ||
            this.state.eightBusinessDaysFromCurrentDate.includes(formattedDate);
    }

    render() {
        if (this.state.redirect) {
            return <Redirect to="/account" />
        }
        const header = 'Case Details';
        const desc = 'Case Details & list of cases';
        const disabled = this.state.patient.status === 'ready' || this.state.patient.isArchived;
        const isPreviousStatusOnHold = this.state.prevStatus === globals.PATIENT.STATUS.ON_HOLD;
        const disabledOnhold = this.state.patient.status === globals.PATIENT.STATUS.ON_HOLD;
        const pending = this.state.patient.status === 'pending';
        const scheduled = this.state.patient.status === 'scheduled';
        const received = this.state.patient.status === 'received';
        const overdue = this.state.patient.status === 'overdue';
        const rejected = this.state.patient.status === 'rejected';
        const inputClassname = disabled || overdue ? 'desabledInput' : '';
        const totalNumber = disabled || overdue ? 'desabledInput' : '';
        const rejectedDisabled = rejected ? 'desabledInput' : '';
        const rejectedOnly = rejected ? 'desabledInput' : '';
        const onlyReady = disabled ? 'desabledInput' : '';
        const receivedClassname = received ? 'desabledInput' : '';
        const readyScheduledDisabled = (scheduled || disabled) ? 'desabledInput' : '';
        const pendReceivedDisabled = disabled ? 'desabledInput' : '';
        const isEnclosedDisabled = disabled || overdue || rejected || received || disabledOnhold;
        const isImplantPartsDisabled = disabled || overdue || rejected || disabledOnhold || received;
        const isSendingDateDisabled = (!this.state.patient.dateOfReturn && !this.state.patient.sendingDate) || disabled || received || disabledOnhold || (overdue && !isPreviousStatusOnHold);
        const selectInputStyle = disabled || overdue || rejected ?
            {
                backgroundColor: 'transparent',
                cursor: 'default',
                color: '#969494',
                borderBottomColor: '#969494',
                fontWeight: 'normal'
            } :
            {
                fontWeight: 'bold'
            };
        const isSubCase = this.props.caseDetails.caseList.caseDetails && !!this.props.caseDetails.caseList.caseDetails.parent_id
        const hasNoMisc = this.state.availableUnits && !this.state.availableUnits.misc;
        const hasNoZirconia = this.state.availableUnits && !this.state.availableUnits.zirconia;
        return (
            <div className="view">
                <ViewHeader
                    handleSave={(event) => this.handleSaveBooking(event)}
                    showSaveButton={true}
                    saveDisabled={this.state.buttonDisabled || this.props.caseDetails.editingDataLoading}
                    header={header}
                    desc={desc}
                    disabled={this.state.patient.isArchived || isSubCase}
                    openSubCaseModal={this.toggleSubcaseFormModal}
                />
                <div className="view-content dentist__dashboard">
                    <div className="user">
                        <div className="user__block">
                            <div className="user__list">
                                {
                                    (this.props.caseDetails.loading === true) ?
                                        <Spinner/>
                                        :
                                        <PatientsTable
                                            history={this.props.history}
                                        />
                                }
                            </div>
                            <div className="user__cases">
                                {
                                    this.state.isOpenSubcaseForm ?
                                        <SubcaseForm
                                            caseDetails={this.props.caseDetails.caseList.caseDetails}
                                            parent_id={this.state.caseId}
                                            isAdmin={false}
                                            dashboardData={this.props.home.patientList}
                                            dashboard={this.props.home}
                                            toggleSubcaseFormModal={this.toggleSubcaseFormModal}
                                            getData={this.props.getPatient}
                                            isOpenSubcaseForm={this.state.isOpenSubcaseForm}
                                            addPatient={this.props.addPatient}
                                            addBooking={this.props.addBooking}
                                            getCaseDetails={this.props.getCaseDetails}
                                            saveDisabled={this.props.home.addingDataLoading}
                                            minDateForSubcase={this.props.caseDetails.caseList.minDateForSubcase}
                                            bridges={this.state.patient.bridges}
                                            checkedTeeth={this.state.checkedTeeth}
                                            makeBridge={(from,to)=>this.makeBridge(from,to)}
                                        />
                                        : ''
                                }
                                {
                                    (this.props.caseDetails.editingDataLoading === true || this.props.vacationDaysLoading) ?
                                        <Spinner/>
                                        :
                                        <div className="user-details">
                                            <div className="user-details__header">
                                                <div className="user-details__title">
                                                    <div className="header-case-status">
                                                        <span>Status: </span>
                                                        <span className="cs-status">{this.state.patient.isArchived ? 'Archived' : this.state.patient.status}</span>
                                                    </div>
                                                    <button
                                                        className="back-to"
                                                        data-toggle="tooltip"
                                                        onClick={() => this.state.showImages ? this.setState({showImages: false}) : this.handleGoBack()}
                                                    >
                                                        <span className="kr kr-arrow"/>
                                                    </button>
                                                    <h2>Case {this.caseDetails && this.caseDetails.id}</h2>
                                                </div>
                                                <div className="user-details__action">
                                                    <button
                                                        type='button'
                                                        disabled={this.state.patient.isArchived}
                                                        className="no-shadow-btn btn delete_button"
                                                        onClick={() => this.toggleCancelModal()}
                                                    >
                                                        <span className="kr kr-delete"/>
                                                        Delete Case
                                                    </button>
                                                    <ReactToPrint
                                                        trigger={() => <a className="btn btn-link"><span
                                                            className="kr kr-print"/>Print</a>}
                                                        content={() => this.componentRef}
                                                    />
                                                </div>
                                            </div>
                                            {this.state.showImages &&
                                                <Images
                                                    onImageChange={() => this.setState({ isDirty: true, buttonDisabled: false })}
                                                    images={this.state.patient.images}
                                                    //buttonDisabled={this.state.buttonDisabled}
                                                    handleSaveBooking={(event) => this.handleSaveBooking(event)}
                                                    handleChange={(event, type) => this.handleChange(event, type)}
                                                    removeImage={(filename) => this.removeImage(filename)}
                                                    dentistId={this.props.caseDetails.caseList.dentistId}
                                                    caseId={this.state.caseId}
                                                    isForm={false}
                                                    status={this.state.patient.status}
                                                    className={`save-photos-block ${this.state.buttonDisabled ? "desabledInput" : ""}`}

                                                    //disabledEdit={disabled || rejected || overdue}
                                                />
                                            }
                                            {!this.state.showImages && <div className="user-details__content">
                                                <form>
                                                    <div className="book">
                                                        <div className="book__block">
                                                            <div className="date">
                                                                <div className="date__today todays-date">
                                                                    <div
                                                                        className="text-field date__field"
                                                                    >
                                                                        <label className="text-field__label"
                                                                               htmlFor="">Date</label>
                                                                        <input
                                                                            type="text"
                                                                            className="text-field__input"
                                                                            placeholder="Date Of Submittion"
                                                                            disabled={true}
                                                                            value={moment(this.state.patient.dateOfSubmission).format("DD/MM/YYYY")}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="date__other date__field">
                                                                    <div className="date__return return-date"
                                                                         check={true} inline="true">
                                                                        <div
                                                                            className={(this.state.validationBooking.returnDate) ? "react-calendar has-error" : "react-calendar"}
                                                                        >
                                                                            <label className='react-calendar__label'>Return
                                                                                Date <span className="asterisk">*</span></label>
                                                                            <div className="react-calendar__field">
                                                                                <span className="kr kr-calendar" />
                                                                                    <DatePicker
                                                                                    filterDate={date => !this.isDateDisabled(date) || this.formatDate(date) === this.props.caseDetails.caseList.caseDetails.date_of_return}
                                                                                    dayClassName={date => this.isDateDisabled(date) ? 'disabled_date' : ''}
                                                                                    placeholderText={"Select return date"}
                                                                                    className={`datePickerInput ${pendReceivedDisabled} custom-input`}
                                                                                    disabled={disabled || overdue}
                                                                                    minDate={this.props.caseDetails.caseList && this.props.caseDetails.caseList.caseDetails && this.props.caseDetails.caseList.caseDetails.parent_id ? moment(this.props.caseDetails.caseList.minDateForSubcase) : moment().add(11, 'day')}
                                                                                    dateFormat="DD/MM/YYYY"
                                                                                    selected={this.state.patient.dateOfReturn ? moment(this.state.patient.dateOfReturn) : null}
                                                                                    onChange={this.handleDateChange}/>
                                                                                {this.state.validationBooking.returnDate &&
                                                                                <span className="error-message">Return Date field is required.</span>}
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                    <div className="date__sending sending-date">
                                                                        <div
                                                                            className={(this.state.validationBooking.sendingDate) ? "react-calendar has-error" : "react-calendar"}
                                                                        >
                                                                            <label className='react-calendar__label'>Sending
                                                                                Date <span className="asterisk">*</span></label>
                                                                            <div className="react-calendar__field"
                                                                                 data-for="sendingDate"
                                                                                 data-tip="Please select Return Date first."><span className="kr kr-calendar" />
                                                                                <DatePicker
                                                                                    filterDate={date => !isNonWorkingDay(date,this.props.vacationDays) || !is8BusinessDayBeforeReturnDate(date,this.state.businessDaysBeforeReturnDate)}
                                                                                    dayClassName={date => isNonWorkingDay(date,this.props.vacationDays) || is8BusinessDayBeforeReturnDate(date,this.state.businessDaysBeforeReturnDate) ? 'disabled_date' : ''}                                                                                    className={`datePickerInput ${isSendingDateDisabled ? 'desabledInput' : ''} custom-input`}
                                                                                    disabled={isSendingDateDisabled}
                                                                                    selected={this.state.patient.sendingDate ? moment(this.state.patient.sendingDate) : null}
                                                                                    onChange={(sendingDate) => this.handleChangeSendingDate(sendingDate)}
                                                                                    placeholderText={"Select sending date"}
                                                                                    dateFormat="DD/MM/YYYY"
                                                                                    maxDate={this.getMinSubmissionDate()}
                                                                                    minDate={new Date()}
                                                                                    //maxDate={momentBusiness(this.state.patient.dateOfReturn).businessSubtract(8)}
                                                                                />
                                                                                {this.state.validationBooking.sendingDate &&
                                                                                <span className="error-message">Sending Date field is required.</span>}
                                                                                {!this.state.patient.dateOfReturn && !this.state.patient.sendingDate &&
                                                                                <ReactTooltip place="top"
                                                                                              id="sendingDate"
                                                                                              type="light"
                                                                                              effect="float"/>}
                                                                            </div>
                                                                            </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="dentist">
                                                                <p>Dr. {this.caseDetails && this.caseDetails.dentist_id.first_name + ' ' + this.caseDetails.dentist_id.last_name}</p>
                                                            </div>
                                                            <div className="patient">
                                                                <div className={
                                                                    this.state.validationBooking.patientId ? "patient__block has-error" : "patient__block"}
                                                                >
                                                                    <label className="patient__label">Patient <span
                                                                        className="asterisk">*</span></label>
                                                                    <div className="patient__select">
                                                                        <Select name="patients"
                                                                                placeholder="Select patient"
                                                                                className=""
                                                                                filterOptions={this.filterOptions}
                                                                                value={this.state.patient.patientId}
                                                                                onChange={(selectedOption) => this.handleChangePatient(selectedOption)}
                                                                                options={this.patientList.map((patient, index) => ({
                                                                                    value: patient.id,
                                                                                    label: patient.first_name + ' ' + patient.last_name
                                                                                }))}
                                                                                disabled={disabled || rejected || disabledOnhold || received || overdue}
                                                                        />
                                                                        {this.state.validationBooking.patientId &&
                                                                        <span className="error-message">Patient field is required.</span>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="type">
                                                                <div
                                                                    className={(this.state.validationBooking.type) ? "type__block has-error" : "type__block"}>
                                                                    <label className='type__label'>Type <span
                                                                        className="asterisk">*</span></label>
                                                                    <div className="type__select">
                                                                        <Select name="types"
                                                                                className="booking-select select-box"
                                                                                placeholder="Select Type"
                                                                                matchPos="start"
                                                                                value={this.state.patient.type}
                                                                                onChange={(selectedOption) => this.handleChange('type', selectedOption ? selectedOption.value : selectedOption)}
                                                                                options={[
                                                                                    {
                                                                                        label: 'Prototype',
                                                                                        value: 'prototype',
                                                                                        disabled: hasNoMisc,
                                                                                    },
                                                                                    {
                                                                                        label: 'Zirconia',
                                                                                        value: 'zirconia',
                                                                                        disabled: hasNoZirconia,
                                                                                    },
                                                                                    {
                                                                                        label: 'Ceramic',
                                                                                        value: 'ceramic',
                                                                                        disabled: hasNoZirconia,
                                                                                    },
                                                                                    {
                                                                                        label: 'Temp',
                                                                                        value: 'temp',
                                                                                        disabled: hasNoMisc,
                                                                                    },
                                                                                    {
                                                                                        label: 'Other',
                                                                                        value: 'other',
                                                                                        disabled: hasNoMisc,
                                                                                    }
                                                                                ]}
                                                                                disabled={disabled || overdue}
                                                                        />
                                                                    </div>
                                                                    {this.state.validationBooking.type &&
                                                                    <span
                                                                        className="error-message">Type is required.</span>}
                                                                </div>
                                                            </div>
                                                            <div className="total-units">
                                                                <div className="total-units__block">
                                                                    <div
                                                                        className={(this.state.validationBooking.numberOfUnits) || (this.state.numberOfUnits < 0) ? "text-field has-error" : "text-field"}
                                                                    >
                                                                        <label className="text-field__label" htmlFor="">Total
                                                                            no. of units <span
                                                                                className="asterisk">*</span></label>
                                                                        <input
                                                                            className="text-field__input"
                                                                            type="number"
                                                                            placeholder="0"
                                                                            disabled={disabled || overdue || disabledOnhold}
                                                                            value={this.state.patient.numberOfUnits}
                                                                            onChange={(e) => this.handleChange('numberOfUnits', e.target.value)}
                                                                        />
                                                                        {(this.state.validationBooking.numberOfUnits) ? (this.state.numberOfUnits < 0) ?
                                                                            <span className="error-message">Please enter a valid number.</span> :
                                                                            <span className="error-message">Number of units field is required.</span> : ''}
                                                                    </div>
                                                                    <div className="units__available">
                                                                        <div>
                                                                            Available units:
                                                                            {` Zirc/Cer: ${this.state.availableUnits && this.state.availableUnits.zirconia}
                                                                                    Misc: ${this.state.availableUnits && this.state.availableUnits.misc} `}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="total-units__block">
                                                                    <div className="implant">
                                                                        <label className="implant__label">Implant <span
                                                                            className="asterisk">*</span></label>
                                                                        <div className="implant__radio">
                                                                            <div check={true}
                                                                                 className="radio-button custom-control custom-radio">
                                                                                <input
                                                                                    disabled={disabled || overdue || disabledOnhold}
                                                                                    className="custom-control-input"
                                                                                    value={1}
                                                                                    id="implant-4"
                                                                                    onChange={(e) => this.handleChange('implant', e.target.value)}
                                                                                    type="radio"
                                                                                    checked={this.state.patient.implant === IMPLANT_IS_CHECKED ? true : false}
                                                                                    name="implant3"
                                                                                />
                                                                                <label className="custom-control-label"
                                                                                       htmlFor="cr-sub-implant-0">
                                                                                    Yes
                                                                                </label>
                                                                            </div>
                                                                            <div check={true}
                                                                                 className="radio-button custom-control custom-radio">
                                                                                <input
                                                                                    disabled={disabled || overdue || disabledOnhold}
                                                                                    className="custom-control-input"
                                                                                    value={0}
                                                                                    id="implant-5"
                                                                                    onChange={(e) => this.handleChange('implant', e.target.value)}
                                                                                    type="radio"
                                                                                    checked={this.state.patient.implant === '0' ? true : false}
                                                                                    name="implant3"
                                                                                />
                                                                                <label className="custom-control-label"
                                                                                       htmlFor="cr-sub-implant-1">
                                                                                    No
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {this.state.validationBooking.implant &&
                                                                    <span className="error-message">Implant must be yes or no.</span>}
                                                                </div>
                                                            </div>
                                                            <div className="upload">
                                                                <Images
                                                                    handleChange={(key, value,isDirty) => this.handleChange(key, value,"",isDirty)}
                                                                    onImageChange={() => this.setState({ isDirty: true, buttonDisabled: false })}
                                                                    handleCountChange={this.handleCountChange}
                                                                    handleSeeMore={() => this.handleSeeMore()}
                                                                    buttonDisabled={disabled || rejected || overdue}
                                                                    hasErrorImages={this.state.hasErrorImages}
                                                                    images={this.state.patient.images}
                                                                    removeImage={(name) => this.removeImage(name)}
                                                                    isForm={true}
                                                                    dentistId={this.props.caseDetails.caseList.dentistId}
                                                                    caseId={this.state.caseId}
                                                                    status={this.state.patient.status}
                                                                    disabledEdit={disabled || rejected || overdue}
                                                                    //showMore={this.state.showImages}
                                                                />
                                                            </div>
                                                            <div>
                                                                {this.props.caseDetails.caseList.history && this.props.caseDetails.caseList.history.length > 0 ?
                                                                    <HistoryWrapper
                                                                        caseId={this.state.caseId}
                                                                    /> : ''}
                                                            </div>
                                                        </div>
                                                        <div className="book__block">
                                                            <div className="add-info-title">
                                                                <h6>Additional information</h6>
                                                            </div>
                                                            <div className="color">
                                                                <div
                                                                    className="text-field"
                                                                >
                                                                    <label className="text-field__label"
                                                                           htmlFor="">Color</label>
                                                                    <input
                                                                        className="text-field__input"
                                                                        value={this.state.patient.color}
                                                                        type="text"
                                                                        placeholder=""
                                                                        onChange={(e) => this.handleChange('color', e.target.value)}
                                                                        disabled={disabled || overdue || rejected || disabledOnhold}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="cases-notes">
                                                                <div
                                                                    className="text-field textarea"
                                                                >
                                                                    <label className="text-field__label" htmlFor="">Case notes</label>
                                                                    <div
                                                                        className={`textarea__block ${disabled || overdue || rejected ? 'is-disabled' : ''} ${this.state.isTextareaFocused ? 'textarea__block--focused' : ''}`}>
                                                                            <textarea
                                                                                className="text-field__input"
                                                                                key="notes"
                                                                                value={this.state.patient.notes}
                                                                                onChange={(e) => this.handleChange('notes', e.target.value)}
                                                                                rows={3}
                                                                                disabled={disabled || overdue || rejected}
                                                                            />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="signature">
                                                                <div
                                                                    className="text-field"
                                                                >
                                                                    <label className="text-field__label"
                                                                           htmlFor="">Signature</label>
                                                                    <input
                                                                        className="text-field__input"
                                                                        disabled={disabled}
                                                                        value={this.state.patient.signature}
                                                                        type="text"
                                                                        placeholder=""
                                                                        onChange={(e) => this.handleChange('signature', e.target.value)}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="license">
                                                                <div
                                                                    className="text-field"
                                                                >
                                                                    <label className="text-field__label"
                                                                           htmlFor="">License</label>
                                                                    <input
                                                                        className="text-field__input"
                                                                        disabled={disabled}
                                                                        value={this.state.patient.license}
                                                                        type="text"
                                                                        placeholder=""
                                                                        onChange={(e) => this.handleChange('license', e.target.value)}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="book__block">
                                                            <div className="enclosed">
                                                                <h6 className="enclosed__title">Enclosed in the
                                                                    box <span className="asterisk">*</span></h6>
                                                                {
                                                                    Object.keys(this.state.enclosedBoxObject).map((value, index) => {
                                                                        let find = this.state.patient.enclosedBox.find(item => {
                                                                            return (item === parseInt(value, 10))
                                                                        })
                                                                        return (
                                                                            <div key={index} className="enclosed__list">
                                                                                <div check={true}
                                                                                     className="checkbox custom-control custom-checkbox">
                                                                                    <input
                                                                                        id={this.state.enclosedBoxObject[value].name.replace(/\s|\//g, '_')}
                                                                                        disabled={isEnclosedDisabled}
                                                                                        type="checkbox"
                                                                                        className="custom-control-input"
                                                                                        name="type"
                                                                                        value={value}
                                                                                        onChange={(e) => this.handleChange('enclosedBox', parseInt(e.target.value, 10))}
                                                                                        checked={find !== undefined ? true : false}
                                                                                    />
                                                                                    <label
                                                                                        htmlFor={this.state.enclosedBoxObject[value].name.replace(/\s|\//g, '_')}
                                                                                        className="checkbox-label custom-control-label"
                                                                                    >
                                                                                        {this.state.enclosedBoxObject[value].name}
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                                {this.state.validationBooking.enclosedBox &&
                                                                <FormText>Choose at least one of the above.</FormText>}
                                                            </div>
                                                            {this.state.patient.implant === IMPLANT_IS_CHECKED &&
                                                            <Fragment>
                                                                <div className="implant-block">
                                                                    <div
                                                                        className="text-field"
                                                                    >
                                                                        <label className="text-field__label" htmlFor="">Implant
                                                                            Type</label>
                                                                        <input
                                                                            className="text-field__input"
                                                                            disabled={disabled || overdue || rejected || disabledOnhold}
                                                                            value={this.state.patient.implantType}
                                                                            type="text"
                                                                            placeholder=""
                                                                            onChange={(e) => this.handleChange('implantType', e.target.value)}
                                                                        />
                                                                    </div>
                                                                    <div
                                                                        className="text-field"
                                                                    >
                                                                        <label className="text-field__label" htmlFor="">Implant
                                                                            Size</label>
                                                                        <input
                                                                            className="text-field__input"
                                                                            disabled={disabled || overdue || rejected || disabledOnhold}
                                                                            value={this.state.patient.implantSize}
                                                                            type="text"
                                                                            placeholder=""
                                                                            onChange={(e) => this.handleChange('implantSize', e.target.value)}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="parts">
                                                                    <h6 className="parts__title">Implant Parts:</h6>
                                                                    {
                                                                        Object.keys(this.state.implantsPartObject).map((value, index) => {
                                                                            let find = Object.keys(this.state.patient.implantParts).find(item => {
                                                                                return (item === value)
                                                                            })
                                                                            return (
                                                                                <div key={index}
                                                                                     className="parts__list">
                                                                                    <div check={true}
                                                                                         className="checkbox custom-control custom-checkbox">
                                                                                        <input
                                                                                            id={this.state.implantsPartObject[value].name.replace(/\s|\//g, '__')}
                                                                                            type="checkbox"
                                                                                            className="custom-control-input"
                                                                                            name="type"
                                                                                            value={value}
                                                                                            onChange={(e) => this.handleChange('implantParts', e.target.value)}
                                                                                            disabled={isImplantPartsDisabled}
                                                                                            checked={this.state.patient.implantParts[value] !== undefined ? true : false}
                                                                                        />
                                                                                        <label
                                                                                            htmlFor={this.state.implantsPartObject[value].name.replace(/\s|\//g, '__')}
                                                                                            className="checkbox-label custom-control-label"
                                                                                        >
                                                                                            {this.state.implantsPartObject[value].name}
                                                                                        </label>
                                                                                    </div>
                                                                                    {(find !== undefined) ?
                                                                                        <div
                                                                                            className={`text-field ${this.state.validationBooking.implantParts ? "has-error" : ""}`}
                                                                                        >
                                                                                            <input
                                                                                                className="text-field__input"
                                                                                                disabled={isImplantPartsDisabled}
                                                                                                value={this.state.patient.implantParts[find]}
                                                                                                type="number"
                                                                                                placeholder=""
                                                                                                onChange={(e) => this.handleChange('implantParts', e.target.value, find)}
                                                                                            />
                                                                                            {this.state.validationBooking.implantParts && <span className="error-message">Required</span>}
                                                                                        </div> : ''}
                                                                                </div>
                                                                            )
                                                                        })
                                                                    }
                                                                </div>
                                                            </Fragment>}
                                                        </div>
                                                    </div>
                                                    <div ref={this.bridgesRef} className="print-bridge">
                                                        <div className="print-bridge__container">
                                                            <div className="print-bridge__block">
                                                                <div className='t-left'>
                                                                    {
                                                                        Object.keys(this.state.bridgesStructure.top.left).map((key)=>{
                                                                            return <Fragment>
                                                                                <div className={`t-item ${this.state.checkedTeeth.includes(this.state.bridgesStructure.top.left[key].number) ? 'checked' : ''}`} onClick={()=>this.makeBridge(this.state.bridgesStructure.top.left[key].number,this.state.bridgesStructure.top.left[key].number)}>
                                                                                    {this.state.bridgesStructure.top.left[key].number}
                                                                                </div>
                                                                                {this.state.bridgesStructure.top.left[key].number !== 18 && <span
                                                                                    className={
                                                                                        `${this.state.patient.bridges && this.state.patient.bridges.some(item => item.from === this.state.bridgesStructure.top.left[key].number && item.to === this.state.bridgesStructure.top.left[key].number+1) && 'checked_bridge'}
                                                     bottom-bridge ${this.state.patient.bridges && this.state.patient.bridges.map((item)=>{if(item.from ===this.state.bridgesStructure.top.left[key].number && item.to === this.state.bridgesStructure.top.left[key].number+1){ return 'checked_bridge'}})}
                                                     ${'bottom-bridge-' + this.state.bridgesStructure.top.left[key].number + '-' + parseFloat(this.state.bridgesStructure.top.left[key].number + 1)}`}
                                                                                    onClick={() => this.makeBridge(this.state.bridgesStructure.top.left[key].number, this.state.bridgesStructure.top.left[key].number + 1)}
                                                                                >
                                            </span>}
                                                                            </Fragment>

                                                                        })
                                                                    }
                                                                </div>
                                                                <div className="t-center">
                                                                    {
                                                                        Object.keys(this.state.bridgesStructure.top.center).map((key)=>{
                                                                            return <Fragment>
                                                                                {
                                                                                    this.state.bridgesStructure.top.center[key].number === 12 &&
                                                                                    <span
                                                                                        className={`
                                                    ${this.state.patient.bridges && this.state.patient.bridges.some(item => item.from === this.state.bridgesStructure.top.center[key].number && item.to === this.state.bridgesStructure.top.center[key].number+1) && 'checked_bridge'}
                                                    ${this.state.bridgesStructure.top.center[key].number === 12 && 'left-bridge'} right-bridge ${'right-bridge-'+this.state.bridgesStructure.top.center[key].number+'-'+parseFloat(this.state.bridgesStructure.top.center[key].number + 1)}`}
                                                                                        onClick={()=>this.makeBridge(this.state.bridgesStructure.top.center[key].number,this.state.bridgesStructure.top.center[key].number+1)}
                                                                                    />
                                                                                }
                                                                                <div className={`t-item ${this.state.checkedTeeth.includes(this.state.bridgesStructure.top.center[key].number) ? 'checked' : ''}`} onClick={()=>this.makeBridge(this.state.bridgesStructure.top.center[key].number,this.state.bridgesStructure.top.center[key].number)}>
                                                                                    {this.state.bridgesStructure.top.center[key].number}
                                                                                </div>
                                                                                <span
                                                                                    className={`
                                                ${this.state.patient.bridges && this.state.patient.bridges.some(item => this.state.bridgesStructure.top.center[key].number === 11 ? item.from === 11 && item.to === 21 : item.from === this.state.bridgesStructure.top.center[key].number && item.to === this.state.bridgesStructure.top.center[key].number+1 && item.to !== 13) && 'checked_bridge'}
                                                ${this.state.patient.bridges && this.state.patient.bridges.some(item => this.state.bridgesStructure.top.center[key].number === 11 ? item.from === 11 && item.to === 21 : item.from === this.state.bridgesStructure.top.center[key].number && item.to === this.state.bridgesStructure.top.center[key].number+1 || this.state.bridgesStructure.top.center[key].number === 12 ? item.from === 12 && item.to === 11 : null) && 'checked_bridge'}
                                                ${this.state.bridgesStructure.top.center[key].number === 12 && 'left-bridge'} right-bridge ${'right-bridge-'+this.state.bridgesStructure.top.center[key].number+'-'+parseFloat(this.state.bridgesStructure.top.center[key].number + 1)}`}
                                                                                    onClick={()=>this.state.bridgesStructure.top.center[key].number === 12 ? this.makeBridge(this.state.bridgesStructure.top.center[key].number,this.state.bridgesStructure.top.center[key].number-1) : this.makeBridge(this.state.bridgesStructure.top.center[key].number,this.state.bridgesStructure.top.center[key].number+1)}
                                                                                />
                                                                            </Fragment>

                                                                        })
                                                                    }
                                                                    <div className="u-title">Upper Jaw</div>
                                                                </div>
                                                                <div className="t-right">
                                                                    {
                                                                        Object.keys(this.state.bridgesStructure.top.right).map((key)=>{
                                                                            return <Fragment>
                                                                                <div className={`t-item ${this.state.checkedTeeth.includes(this.state.bridgesStructure.top.right[key].number) ? 'checked' : ''}`} onClick={()=>this.makeBridge(this.state.bridgesStructure.top.right[key].number,this.state.bridgesStructure.top.right[key].number)}>
                                                                                    {this.state.bridgesStructure.top.right[key].number}
                                                                                </div>
                                                                                {this.state.bridgesStructure.top.right[key].number !== 28 && <span
                                                                                    className={`
                                                    ${this.state.patient.bridges && this.state.patient.bridges.some(item => item.from === this.state.bridgesStructure.top.right[key].number && item.to === this.state.bridgesStructure.top.right[key].number+1) && 'checked_bridge'}
                                                    bottom-bridge ${'bottom-bridge-' + this.state.bridgesStructure.top.right[key].number + '-' + parseFloat(this.state.bridgesStructure.top.right[key].number + 1)}`}
                                                                                    onClick={() => this.makeBridge(this.state.bridgesStructure.top.right[key].number, this.state.bridgesStructure.top.right[key].number + 1)}
                                                                                >
                                            </span>}
                                                                            </Fragment>

                                                                        })
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div className="print-bridge__block">
                                                                <div className='t-left'>
                                                                    {
                                                                        Object.keys(this.state.bridgesStructure.bottom.left).map((key)=>{
                                                                            return <Fragment>
                                                                                <div className={`t-item ${this.state.checkedTeeth.includes(this.state.bridgesStructure.bottom.left[key].number) ? 'checked' : ''}`} onClick={()=>this.makeBridge(this.state.bridgesStructure.bottom.left[key].number,this.state.bridgesStructure.bottom.left[key].number)}>
                                                                                    {this.state.bridgesStructure.bottom.left[key].number}
                                                                                </div>
                                                                                {this.state.bridgesStructure.bottom.left[key].number !== 43 && <span
                                                                                    className={`${this.state.patient.bridges && this.state.patient.bridges.some(item => item.from === this.state.bridgesStructure.bottom.left[key].number-1 && item.to === this.state.bridgesStructure.bottom.left[key].number) && 'checked_bridge'}
                                                bottom-bridge ${'bottom-bridge-' + this.state.bridgesStructure.bottom.left[key].number + '-' + parseFloat(this.state.bridgesStructure.bottom.left[key].number + 1)}`}
                                                                                    onClick={() => this.makeBridge(this.state.bridgesStructure.bottom.left[key].number-1, this.state.bridgesStructure.bottom.left[key].number)}
                                                                                >
                                            </span>}
                                                                            </Fragment>

                                                                        })
                                                                    }
                                                                </div>
                                                                <div className="t-center">
                                                                    {
                                                                        Object.keys(this.state.bridgesStructure.bottom.center).map((key)=>{
                                                                            return <Fragment>
                                                                                {
                                                                                    this.state.bridgesStructure.bottom.center[key].number === 42 &&
                                                                                    <span
                                                                                        className={`${this.state.patient.bridges && this.state.patient.bridges.some(item => item.from === this.state.bridgesStructure.bottom.center[key].number && item.to === this.state.bridgesStructure.bottom.center[key].number+1) && 'checked_bridge'}
                                                    ${this.state.bridgesStructure.bottom.center[key].number === 42 && 'left-bridge'} right-bridge ${'right-bridge-'+this.state.bridgesStructure.bottom.center[key].number+'-'+parseFloat(this.state.bridgesStructure.bottom.center[key].number + 1)}`}
                                                                                        onClick={()=>this.makeBridge(this.state.bridgesStructure.bottom.center[key].number,this.state.bridgesStructure.bottom.center[key].number+1)}
                                                                                    ></span>
                                                                                }
                                                                                <div className={`t-item ${this.state.checkedTeeth.includes(this.state.bridgesStructure.bottom.center[key].number) ? 'checked' : ''}`} onClick={()=>this.makeBridge(this.state.bridgesStructure.bottom.center[key].number,this.state.bridgesStructure.bottom.center[key].number)}>
                                                                                    {this.state.bridgesStructure.bottom.center[key].number}
                                                                                </div>
                                                                                <span
                                                                                    className={`${this.state.patient.bridges && this.state.patient.bridges.some(item => item.from === this.state.bridgesStructure.bottom.center[key].number && item.to === this.state.bridgesStructure.bottom.center[key].number+1) && this.state.bridgesStructure.bottom.center[key].number !== 42 && 'checked_bridge'}
                                                ${this.state.patient.bridges && this.state.patient.bridges.some(item => this.state.bridgesStructure.bottom.center[key].number === 41 ? item.from === 41 && item.to === 31 : item.from === this.state.bridgesStructure.bottom.center[key].number && item.to === this.state.bridgesStructure.bottom.center[key].number+1 || this.state.bridgesStructure.bottom.center[key].number === 42 ? item.from === 42 && item.to === 41 : null) && 'checked_bridge'}
                                                 right-bridge ${'right-bridge-'+this.state.bridgesStructure.bottom.center[key].number+'-'+parseFloat(this.state.bridgesStructure.bottom.center[key].number + 1)}`}
                                                                                    onClick={()=>this.state.bridgesStructure.bottom.center[key].number === 42 ? this.makeBridge(this.state.bridgesStructure.bottom.center[key].number,this.state.bridgesStructure.bottom.center[key].number-1) : this.makeBridge(this.state.bridgesStructure.bottom.center[key].number,this.state.bridgesStructure.bottom.center[key].number+1)}
                                                                                >
                                            </span>
                                                                            </Fragment>
                                                                        })
                                                                    }
                                                                    <div className="l-title">Lower Jaw</div>
                                                                </div>
                                                                <div className="t-right">
                                                                    {
                                                                        Object.keys(this.state.bridgesStructure.bottom.right).map((key)=>{
                                                                            return <Fragment>
                                                                                <div className={`t-item ${this.state.checkedTeeth.includes(this.state.bridgesStructure.bottom.right[key].number) ? 'checked' : ''}`} onClick={()=>this.makeBridge(this.state.bridgesStructure.bottom.right[key].number,this.state.bridgesStructure.bottom.right[key].number)}>
                                                                                    {this.state.bridgesStructure.bottom.right[key].number}
                                                                                </div>
                                                                                {this.state.bridgesStructure.bottom.right[key].number !== 33 && <span
                                                                                    className={`${this.state.patient.bridges && this.state.patient.bridges.some(item => item.from === this.state.bridgesStructure.bottom.right[key].number && item.to === this.state.bridgesStructure.bottom.right[key].number-1) && 'checked_bridge'}
                                                bottom-bridge ${'bottom-bridge-' + this.state.bridgesStructure.bottom.right[key].number + '-' + parseFloat(this.state.bridgesStructure.bottom.right[key].number + 1)}`}
                                                                                    onClick={() => this.makeBridge(this.state.bridgesStructure.bottom.right[key].number, this.state.bridgesStructure.bottom.right[key].number-1)}
                                                                                >
                                            </span>}
                                                                            </Fragment>

                                                                        })
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        className={`details-actions ${this.state.approvable ? "for-request" : ""}`}>
                                                        <div>
                                                            <button
                                                                className="no-shadow-btn btn btn-outline"
                                                                onClick={() => this.cancelEdits()}>
                                                                Cancel
                                                            </button>
                                                            <button
                                                                type='button'
                                                                className={`no-shadow-btn btn btn-primary ${this.state.approvable ? "request-btn" : ""}`}
                                                                disabled={this.state.buttonDisabled || this.props.caseDetails.editingDataLoading}
                                                                onClick={(event) => this.handleSaveBooking(event)}>
                                                                {this.state.approvable ? 'Request Change' : 'Save'}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>}
                                        </div>
                                }
                            </div>
                            <ViewForPrinting
                                ref={el => (this.componentRef = el)}
                                implantsPartObject={this.state.implantsPartObject}
                                enclosedBoxObject={this.state.enclosedBoxObject}
                                patient={this.state.patient}
                                patientName={this.getPatientNameById(parseInt(this.state.patient.patientId, 10))}
                                dentistName={this.caseDetails && this.caseDetails.dentist_id.first_name + ' ' + this.caseDetails.dentist_id.last_name}
                                isAdmin={false}
                            />
                            {
                                this.state.showEditModal &&
                                <ModalComponent
                                    modalHeaderStyle="modalHeaderDefault"
                                    headerTitle={this.state.modalHeader}
                                    modalBody={this.state.modalBody}
                                    show={this.state.showEditModal}
                                    handleClose={() => this.handleClose('close')}
                                    buttonText="Change"
                                    buttonDisabled={this.state.buttonDisabled || this.props.caseDetails.editingDataLoading}
                                    buttonFunction={(event) => this.handleSaveBooking(event)}
                                />
                            }
                            {
                                this.state.cancelCaseModal &&
                                <ModalComponent
                                    modalHeaderStyle="modalHeaderDefault"
                                    headerTitle="Delete Case"
                                    modalBody="Are you sure you want to delete the case?"
                                    show={this.state.cancelCaseModal}
                                    handleClose={() => this.handleClose()}
                                    buttonText="Yes"
                                    buttonFunction={() => this.cancelBooking(this.state.caseId)}
                                />
                            }
                            {
                                this.state.printModal &&
                                <ModalComponent
                                    modalHeaderStyle="modalHeaderDefault"
                                    headerTitle="Print Booking"
                                    modalBody={"Would you like to print the case?"}
                                    printCase={this.state.printModal}
                                    show={this.state.printModal}
                                    caseDetails={this.props.home.patientList}
                                    handleClose={this.togglePrintModal}
                                    buttonText="Yes"
                                    isAdmin={false}
                                />
                            }
                            {
                                this.state.isOpenPickupModal &&
                                <ModalComponent
                                    modalHeaderStyle="modalHeaderDefault"
                                    headerTitle="Schedule Pickup"
                                    modalBody="Is the case ready for pickup?"
                                    show={this.state.isOpenPickupModal}
                                    isPickupModal={true}
                                    caseDetails={this.props.home.caseList}
                                    handleClose={() => this.handleClosePickupModal()}
                                    buttonText="Yes"
                                    buttonFunction={() => this.schedulePickup()}
                                    isAdmin={false}
                                />
                            }
                            {
                                this.state.isCancelCaseModalOpened &&
                                <ModalComponent
                                    modalHeaderStyle="modalHeader"
                                    headerTitle="Delete Case"
                                    modalBody="Are you sure you want to cancel the booking?"
                                    show={this.state.isCancelCaseModalOpened}
                                    handleClose={() => this.toggleCancelModal()}
                                    buttonText="Delete"
                                    buttonFunction={() => this.cancelBooking()}
                                />
                            }
                            {
                                this.state.patient.images.length ?
                                    <ModalComponent/> : ''
                            }

                        </div>
                    </div>
                </div>
                <RouteLeavingGuard
                    when={this.state.isDirty}
                    shouldBlockNavigation={this.state.isDirty}
                    approvable={this.state.approvable}
                    navigate={path => {
                        this.setState({ isDirty: false }, () => this.props.history.push(path))
                    }}
                    saveChanges={(event, location) => this.handleSaveBooking(event, location.pathname)}
                />
            </div>
        );
    }
};

const mapStateToProps = dispatch => {
    return {
        imageUpload: dispatch.imageUploadReducer,
        bridges: dispatch.caseDetails.caseList.bridges,
        vacationDays: dispatch.adminDashboard.vacationDays,
        vacationDaysLoading: dispatch.adminDashboard.vacationDaysRequestLoading,
        caseIsDeleted: dispatch.caseDetails.cancelCase,
        caseDetails: dispatch.caseDetails,
        home: dispatch.home
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getCase: (caseId) => { dispatch(getCase(caseId)); },
        editCase: (data) => { dispatch(editCase(data)); },
        cancelCase: (data) => { dispatch(cancelCase(data)); },
        getAvailableUnits: (data) => { dispatch(getAvailableUnits(data)); },
        addPatient: (data) => { dispatch(addPatient(data)); },
        addBooking: (data) => { dispatch(addBooking(data)); },
        getPatient: (data) => { dispatch(getPatient(data)); },
        addPickup: (caseId, isPickup) => { dispatch(addPickup(caseId, isPickup)); },
        getCaseDetails: (caseId) => { dispatch(getCaseDetails(caseId)); },
        getVacationDays: () => { dispatch(getVacationDaysRequest())},
        startImageUploading: (data) => {
            dispatch(startImageUploading(data))
        },
        removeAllUploads: () => {
            dispatch(removeAllImageUploads());
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(CaseDetails);



// WEBPACK FOOTER //
// ./src/containers/Layouts/User/CaseDetails/index.js